import {ReactNode, useEffect, useState} from "react"
import {ReminderContext} from "../contexts/ReminderContext"
import {IReminder} from "../interfaces/IReminder";
import {useAuth} from "../hooks/useAuth";
import {ReminderNotification} from "../components/reminder/ReminderNotification";

export const ReminderProvider = ({children}: { children: ReactNode }) => {
    const {user, setUser} = useAuth();

    const [isVisible, setIsVisible] = useState(false);
    const [reminder, setReminder] = useState<IReminder | null>(null);

    const updateReminder = (reminderToUpdate: IReminder) => {
        const reminder = user?.reminders.find(x => x.id === reminderToUpdate.id);
        if (reminder)
            reminder.isDisplayed = true;
        setUser(user);
        // console.log('data;' , user);

        // setUser((prevState) => ({
        //     ...prevState,
        //     reminders: prevState?.reminders.map(x => x.id === reminderToUpdate.id ? reminderToUpdate: x)
        // } as IUser));
    }

    const showReminder = (reminder: IReminder) => {
        setReminder(reminder);
        setIsVisible(true);
    }

    const closeReminder = () => {
        setIsVisible(false);
        setReminder(null);
    }

    const isTimeToShowReminder = (reminder: IReminder): boolean => {
        var currentTime = new Date();
        currentTime.setSeconds(currentTime.getSeconds() + 10);

        if (reminder.remindAt <= currentTime)
            return true;
        return false;
    }

    const checkForReminder = () => {
        var currentTime = new Date();
        var inFutureReminders = user?.reminders.filter(reminder => reminder.remindAt >= currentTime);
        // console.log("reminders ", user);
        // inFutureReminders?.forEach(reminder =>
        //     // console.log(currentTime, reminder.remindAt)
        // );

        inFutureReminders?.forEach(reminder => {
            if (isTimeToShowReminder(reminder)) {
                // console.log("show");
                showReminder(reminder);
                updateReminder(reminder);
            }
        });
    }

    useEffect(() => {
        // console.log("reminder interval before", user);

        let intervalId: NodeJS.Timeout;
        if (user && user.reminders && user.reminders.length > 0) {
            intervalId = setInterval(() => {
                // console.log("reminder interval");
                checkForReminder();
            }, 5000)
        }
        return () => {
            if (intervalId)
                clearInterval(intervalId);
        };
    }, [user?.reminders])

    useEffect(() => {
        if (isVisible === true) {
            setTimeout(() => {
                closeReminder();
            }, 30000);
        }
    }, [isVisible])


    return (
        <ReminderContext.Provider value={{showReminder, closeReminder, isVisible, reminder}}>
            <ReminderNotification/>
            {children}
        </ReminderContext.Provider>
    )
}
